import { Validator } from 'vee-validate';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect } from 'vue-search-select';
import MasterService from './../../../../masterdata/services/masterdata.service';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';
import CONSTANT from './../../../../shared/constants/constant';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
	name: 'otherinformation',
	components: {
		BasicSelect,
		VueElementLoading,
		Treeselect
	},
	props: ['selectedEdit', 'contractidd', 'callingFromClientContract'],
	data() {
		return {
			cycleError: '',
			isLoading: false,
			userName: '',
			contractid: '',
			tctemplate: '',
			templatelist: [],
			selectedTemplate: {
				text: '',
				value: ''
			},
			billigDataList: [{
				id: CONSTANT.BILLING_DATA.MONTHLY,
				label: 'Monthly '
			}, {
				id: CONSTANT.BILLING_DATA.FORTNIGHTLY,
				label: 'Fortnightly'
			}, {
				id: CONSTANT.BILLING_DATA.WEEKLY,
				label: 'Weekly'
			}],
			billigcycleitem: {
				text: null,
				value: null
			},
			billingCycle: null,
			pod: '',
			date1: '',
			date2: '',
			podCharge: '',
			podChargeEnable: false,
			creditPeriod: '',
			creditLimit: '',
			advancePayment: '',
			creditAlert: '',
			paymentmode: [],
			liabilityAmount: '',
			showbutton: true,
			expanded:false,
			accordianTab:{1:false, 2:false, 3:false},
			isftlservicetaken:false,
		}
	},
	computed: {},
	async mounted() {
		var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.userName = userdetail.email;
		await this.getTemplateList();
		if (this.callingFromClientContract && this.callingFromClientContract.name == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
			if(this.callingFromClientContract.newlySelectedTemplateId){
				//From Service Master
				this.contractid = this.callingFromClientContract.id;
				this.getClientContractTermsCondition(this.contractid);

//				this.getContractTermsCondition(this.contractid);
			} else if(this.callingFromClientContract.existingContractTemplateId){
				//from Existing Client service details
				this.contractid = this.callingFromClientContract.id;
				this.getClientContractTermsCondition(this.contractid);
			}
		} else {
			if (this.selectedEdit.id) {
				this.contractid = this.selectedEdit.id;
				this.getContractTermsCondition(this.contractid);
			}else{
				this.contractid = this.contractidd;
				if(this.contractid){
					this.getContractTermsCondition(this.contractid);
				}
			}
		}
		if (this.selectedEdit.view == true) {
			this.showbutton = false;
		}
	},
	methods: {
		expandAll(){
			this.expanded = true;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = true;
			}
		},
		collapseAll(){
			this.expanded = false;
			for (var key in this.accordianTab) {
				this.accordianTab[key] = false;
			}
		},
		toggleCheck(tabid){
			this.expanded = false;
			for (var key in this.accordianTab) {
				if(tabid != key){
					this.accordianTab[key] = false;
				}
			}
		},
		isIntegerOnlty: function(evt) {
			evt = (evt) ? evt : window.event;
			var charCode = (evt.which) ? evt.which : evt.keyCode;
			if (charCode < 48 || charCode > 57) {
			  evt.preventDefault();;
			} else {
			  return true;
			}
		},
		async getContractTermsCondition(contractid) {
			try {
				this.isLoading = true;
				let input = {
					contractid: contractid
				}
				var result = await MasterService.getContractTermsCondition(input)
				var data = result.data.data[0];
				if(result.data.data.length==1){
					this.isftlservicetaken = result.data.data[0].isftlservicetaken;
				}else{
					this.isftlservicetaken = result.data.data[1].isftlservicetaken;
				}
				await this.setTemplatDetails(data);
				this.isLoading = false;
			} catch (err) {
				console.log(err);
			}
		},
		async getClientContractTermsCondition(contractid){
			try {
				this.isLoading = true;
				let input = {
					contractid: contractid
				}
				var result = await ClientService.checkClientTermsConditionDetails(input)
				var data = result.data.data[0];
				if(result.data.data.length==1){
					this.isftlservicetaken = result.data.data[0].isftlservicetaken;
				}else{
					this.isftlservicetaken = result.data.data[1].isftlservicetaken;
				}
				await this.setTemplatDetails(data);
				this.isLoading = false;
			} catch (err) {
				console.log(err);
			}
		},
		async getTemplateList() {
			this.isLoading = true;
			this.templatelist = []
			var result = await MasterService.getTemplateListForDropDown({})
			for (var i = 0; i < result.data.data.length; i++) {
				this.templatelist.push({
					text: result.data.data[i].termsconditionname,
					value: result.data.data[i].id
				})
			}
			this.isLoading = false;
		},
		selectTemplate(template) {
			this.selectedTemplate = template
			this.tctemplate = template.value
			this.resetAddForm()
			this.getTCTemplateDetail(template.value)
		},
		async setTemplatDetails(data){
			if(!data){
				console.log("no record found.")
				return;
			}
			for (var i = 0; i < this.templatelist.length; i++) {
				if (this.templatelist[i].value == data.tctemplateid) {
					this.selectedTemplate = this.templatelist[i];
					this.tctemplate = this.templatelist[i].value;
				}
			}
			this.billingCycle = data.billingcycle;
			this.pod = data.podhardcopyrequired;
			this.podCharge = data.podhardcopycharges;
			if (data.billingcycle == CONSTANT.BILLING_DATA.MONTHLY) {
				this.billigcycleitem = {
					id: CONSTANT.BILLING_DATA.MONTHLY,
					label: "Monthly"
				}
				this.billingCycle = CONSTANT.BILLING_DATA.MONTHLY;
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = '';
			} else if (data.billingcycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
				this.billigcycleitem = {
					id: CONSTANT.BILLING_DATA.FORTNIGHTLY,
					label: "Fortnightly"
				}
				this.billingCycle = CONSTANT.BILLING_DATA.FORTNIGHTLY;
				this.date1 = data.billsubmissionlastdate.cycle1;
				this.date2 = data.billsubmissionlastdate.cycle2;
			}else if (data.billingcycle == CONSTANT.BILLING_DATA.WEEKLY) {
				this.billigcycleitem = {
					id: CONSTANT.BILLING_DATA.WEEKLY,
					label: "Fortnightly"
				}
				this.billingCycle = CONSTANT.BILLING_DATA.WEEKLY;
			}
			this.creditPeriod = data.creditperioddays;
			this.creditLimit = data.creditlimit;
			this.advancePayment = data.ftladvancepayment;
			this.creditAlert = data.creditlimitalert;
			this.paymentmode = data.paymentmode;
			this.liabilityAmount = data.maxliability;
		},
		async getTCTemplateDetail(id) {
			this.isLoading = true;
			var input = {
				"tcid": id
			}
			var result = await MasterService.getTCTemplateDetail(input);
			var data = result.data.data[0];
			await this.setTemplatDetails(data);
			this.isLoading = false;
		},
		selectBillingCycle(billingcycle) {
			this.$nextTick(() => {
				this.date1 = '';
				this.date2 = '';
				this.billigcycleitem = billingcycle
				this.billingCycle = billingcycle.id
			})
		},
		changeCycle() {
			if ((this.date1 == this.date2) && (this.date1 > 0 && this.date2 > 0)) {
				this.cycleError = "Dates should be Different"
				return false;
			} else {
				this.cycleError = ''
			}
		},
		dataSubmit(buttonclick) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					this.accordianTab[2] = true;
					return false;
				} else {
					if ((this.date1 == this.date2) && (this.date1 > 0 && this.date2 > 0)) {
						this.cycleError = "Dates should be Different"
						return false;
					} else {
						this.cycleError = ''
						this.saveContractTnC(buttonclick)
					}
				}
			}).catch(() => {
				console.log('errors exist')
			});
		},
		resetAddForm() {
			this.$nextTick(() => {
				this.$validator.reset();
				this.isLoading = false;
				this.templateNameSearch = '';
				this.templateName = '';
				this.templateDescription = '';
				this.billigcycleitem = {
					value: null,
					text: null
				};
				this.billingCycle = null;
				this.pod = '';
				this.podCharge = '';
				this.podChargeEnable = false;
				this.creditPeriod = '';
				this.creditLimit = '';
				this.date1 = '';
				this.date2 = '';
				this.advancePayment = '';
				this.paymentmode = [];
				this.liabilityAmount = '';
				this.creditAlert = '';
			})
		},
		async saveContractTnC(buttonclick) {
			if (!this.contractid) {
				this.$alert("Contractid is required", this.contractname, "error");
				return false;
			}
			let billsubmissionlastdate = {}
			if (this.billingCycle == CONSTANT.BILLING_DATA.MONTHLY) {
				billsubmissionlastdate = {
					"cycle1": this.date1
				}
			} else if (this.billingCycle == CONSTANT.BILLING_DATA.FORTNIGHTLY) {
				billsubmissionlastdate = {
					"cycle1": this.date1,
					"cycle2": this.date2
				}
			}

			let podcharges;
			if(this.pod==1){
				podcharges = this.podCharge;
			}

			var inputpayload = {
				"tctemplateid": this.tctemplate,
				"billingcycle": this.billingCycle || null,
				"podhardcopyrequired": this.pod || 0,
				"podhardcopycharges": podcharges || null,
				"billsubmissionlastdate": billsubmissionlastdate,
				"creditperioddays": this.creditPeriod || null,
				"creditlimit": this.creditLimit || null,
				"ftladvancepayment": this.advancePayment || null,
				"creditlimitalert": this.creditAlert || null,
				"paymentmode": this.paymentmode,
				"maxliability": this.liabilityAmount || null,
				"status": 1,
				"lastmodifiedby": this.userName
			}

			if (this.callingFromClientContract){
				inputpayload.clientcontractid = this.contractid;
				this.isLoading = true;
				var result = await ClientService.saveclienttermsandcondition(inputpayload);
			}else{
				inputpayload.contractid = this.contractid;
				this.isLoading = true;
				var result = await MasterService.saveContractTCTemplate(inputpayload);
			}
			if (result.data.code == 200) {
				this.$alert(result.data.message, this.contractname, "success");
				if (buttonclick == 'SaveTCAndNext') {
					this.$emit("goBackToTemplate1", this.contractid, buttonclick)
				} else {
					this.$emit("goBackToParent");
				}
			} else {
				this.$alert(result.data.message, this.contractname, "error");
			}
			this.isLoading = false;
		}
	}
}



// WEBPACK FOOTER //
// ./src/modules/shared/components/Template1/t&c/t&c.component.js